<template>
    <div class="on-boarding">
        <div class="step-container container">
            <rich-pretty-info v-show="activeStep === 1">
                <template slot="image">
                    <img src="../../assets/img/illustrations/welcome.svg" height="200" width="200"/>
                </template>
                <template slot="content">
                    <h1>Bienvenue {{ userName }} sur votre compte Rich’en danse</h1>
                    <p>
                        Nous allons vous présenter les différentes fonctionnalités de cette application.
                    </p>
                </template>
                <template slot="actions">
                    <uni-button @click.native="nextStep(1)">Suivant</uni-button>
                </template>
            </rich-pretty-info>

            <rich-pretty-info v-show="activeStep === 2">
                <template slot="image">
                    <img src="../../assets/img/illustrations/family.svg" height="200" width="200"/>
                </template>
                <template slot="content">
                    <h1>Ajoutez les membres de votre famille</h1>
                    <p>
                        Gérez facilement l’ensemble des inscriptions de vos enfants.
                    </p>
                </template>
                <template slot="actions">
                    <uni-button @click.native="nextStep(2)">Suivant</uni-button>
                </template>
            </rich-pretty-info>

            <rich-pretty-info v-show="activeStep === 3">
                <template slot="image">
                    <img src="../../assets/img/illustrations/control.svg" height="200" width="200"/>
                </template>
                <template slot="content">
                    <h1>Inscrivez-les à des cours de danse</h1>
                    <p>
                        En inscrivant tous les membres de votre famille sur le même compte, vous bénéficiez de réductions.
                    </p>
                </template>
                <template slot="actions">
                    <uni-button @click.native="nextStep(3)">Suivant</uni-button>
                </template>
            </rich-pretty-info>

            <rich-pretty-info v-show="activeStep === 4">
                <template slot="image">
                    <img src="../../assets/img/illustrations/payment.svg" height="200" width="200"/>
                </template>
                <template slot="content">
                    <h1>Gardez un suivi des paiements</h1>
                    <p>
                        Sur votre compte vous bénéficiez d’un suivi des paiements que vous faites à l’association Rich’en danse et pouvez télécharger votre attestation CE.
                    </p>
                </template>
                <template slot="actions">
                    <uni-button @click.native="closeOnBoarding">Terminer</uni-button>
                </template>
            </rich-pretty-info>
        </div>
        <div class="overlay"></div>
    </div>
</template>

<script>
    import RichPrettyInfo from "./RichPrettyInfo";
    import UniButton from "../a-elements/UniButton";
    export default {
        name: "OnBoarding",
        components: {UniButton, RichPrettyInfo},
        props:{
            userName: String,
        },
        data(){
            return{
                activeStep: 1
            }
        },
        methods:{
            nextStep(step){
                this.activeStep = step + 1
            },
            closeOnBoarding(){
                this.$emit('onBoardinIsFinish')
            }
        }
    }
</script>

<style scoped lang="scss">
    .on-boarding{
        width: 100vw;
        height: 100vh;
        position:fixed;
        top:0;
        left:0;
        z-index: 15 ;
        background: white;
    }
    .step-container{
        height: 100%;
        width: 100%;
    }
    h1{
        margin-bottom: 12px;
    }

    @include screen-m{
        .on-boarding{
            background: transparent;
            display:flex;
            align-items: center;
            justify-content: center ;
        }
        .overlay{
            height: 100%;
            width: 100%;
            z-index: -1;
            opacity: .85;
            background: var(--color-grey);
            position:fixed;
            top:0;
            left:0;
        }
        .step-container{
            height: 600px;
            width: 500px;
            background: white;
            box-shadow: var(--shadow-s);
            border-radius: 16px;
            padding: 24px;
        }
    }
</style>
